export default function AnalyticsTable({ data }) {
    const rows = data || [];
    const maxCount = Math.max(1, ...rows.map((row) => Number(row.count) || 0));
    const toneDot = {
        red: "bg-rose-400",
        amber: "bg-amber-500",
        green: "bg-emerald-500",
        grey: "bg-slate-400",
    };

    return (
        <section className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm" data-testid="analytics-table">
            <div className="border-b border-slate-100 px-6 py-5">
                <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-400">Детализация</p>
                <h2 className="mt-1 text-xl font-bold text-slate-900">Таблица воронки</h2>
                <p className="mt-1 text-sm text-slate-500">Все этапы и статусы в том же порядке, что и в рабочей воронке.</p>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full min-w-[680px] table-fixed border-collapse">
                    <thead>
                        <tr className="bg-slate-50/80 text-xs font-semibold uppercase tracking-wide text-slate-500">
                            <th className="w-[28%] px-6 py-3 text-left">Этап</th>
                            <th className="w-[52%] px-6 py-3 text-left">Статус</th>
                            <th className="w-[20%] px-6 py-3 text-right">Кандидаты</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                        {rows.map((row, index) => (
                            <tr key={`${row.value || row.name}-${index}`} className="transition-colors hover:bg-slate-50/80">
                                <td className="px-6 py-3.5 text-sm text-slate-500">
                                    <span className="inline-flex items-center gap-2">
                                        <span className={`h-2 w-2 rounded-full ${toneDot[row.tone] || toneDot.grey}`} />
                                        {row.stage || "—"}
                                    </span>
                                </td>
                                <td className="px-6 py-3.5">
                                    <div className="text-sm font-medium text-slate-800">{row.name}</div>
                                    <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100">
                                        <div
                                            className="h-full rounded-full bg-[#cda834]"
                                            style={{ width: `${((Number(row.count) || 0) / maxCount) * 100}%` }}
                                        />
                                    </div>
                                </td>
                                <td className="px-6 py-3.5 text-right text-base font-bold tabular-nums text-slate-900">
                                    {row.count}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    );
}
